import { subscribeToNewsletter } from '../lib/supabase';

// This function handles newsletter signups from the widget
export async function handleNewsletterSignup(email: string, source: string = 'widget') {
  // Basic email validation
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  
  if (!email || !emailRegex.test(email)) {
    return {
      success: false,
      message: 'Please enter a valid email address'
    };
  }

  // Call the Supabase function to add the subscriber
  const result = await subscribeToNewsletter(email, source);
  
  // Track the signup event (if you have analytics)
  if (result.success && typeof gtag !== 'undefined') {
    gtag('event', 'newsletter_signup', {
      event_category: 'OneVoice_Widget',
      event_label: source
    });
  }

  return result;
}

// Export for use in the widget
if (typeof window !== 'undefined') {
  (window as any).handleNewsletterSignup = handleNewsletterSignup;
}